import clsx from "clsx";
import React from "react";

interface TabContentProps {
	id: string;
	activeTab: string;
	content: React.ReactNode;
	loading?: boolean;
}

export function TabContent({
	id,
	activeTab,
	content,
	loading = false,
}: TabContentProps) {
	if (activeTab !== id) {
		return null;
	}

	return (
		<div
			id={`pane-${id}`}
			className={clsx("tab-pane is-active", { "is-loading": loading })}
			aria-labelledby={`tab-${id}`}
			tabIndex={0}
			role="tabpanel"
		>
			{content}
		</div>
	);
}
